import React from "react";
import "./banner.scss";
import Icon from "../icons/icon/icon";
import IconRocket from "../icons/icon-rocket/icon-rocket";
import IconLightBulb from "../icons/icon-light-bulb/icon-light-bulb";

export enum BANNER_VARIANT {
    VARIANT_1 = "variant-1",
    VARIANT_2 = "variant-2",
}

export interface BannerProps {
    content: React.ReactNode;
    variant?: BANNER_VARIANT;
}

const Banner: React.FC<BannerProps> = ({ 
    content, 
    variant = BANNER_VARIANT.VARIANT_1 
}) => {
    const renderIcon = () => {
        switch (variant) {
        case BANNER_VARIANT.VARIANT_1:
            return <Icon Component={() => <IconRocket color="var(--color-accent-1)" />} />;
        case BANNER_VARIANT.VARIANT_2:
            return <Icon Component={() => <IconLightBulb color="var(--color-yellow-score)" />} />;
        default:
            return null;
        }
    };

    return (
        <div className={`banner ${variant}`}>
            <div className="banner-icon">
                {renderIcon()}
            </div>
            <div className="banner-content">{content}</div>
        </div>
    );
};

export default Banner;